import assetPath from '/app/xinglets/lebenslauf/components/frame/src/assets/apple-touch-icon-precomposed.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')